<script lang="ts">
  import type { IUVideo } from "../../core/types";

  export let video: IUVideo;
  export let desc: string = "";

  const UMEDIA_TYPE = 2;
  const init = (n: HTMLElement) => n.setAttribute("allowfullscreen", "true");
</script>

<div class="content">
  <!-- TODO: implement UVideo element in core folder -->
  {#if video.type === UMEDIA_TYPE}
    <!-- svelte-ignore a11y-media-has-caption -->
    <video controls={true} autoplay={false} name="media">
      <source src={video.url} type="video/mp4" />
    </video>
  {:else}
    <iframe
      title="spot video"
      id="ytplayer"
      type="text/html"
      src="{video.url}?autoplay=1&loop={video.loop
        ? '1'
        : '0'}&controls=1&muted=0&showinfo=0"
      use:init
    />
  {/if}

  {#if desc}
    <div class="desc">
      {@html desc}
    </div>
  {/if}
</div>

<style lang="scss">
  iframe,
  video {
    width: 100%;
    height: 190px;

    @include sm {
      height: 300px;
    }

    @include md {
      height: 470px;
    }
  }

  .desc {
    @include normal;
    color: $text-reverse-color;
    padding-bottom: 8px;
    margin-bottom: 80px;
  }
</style>
